
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/link",
      function () {
        return require("private-next-pages/link.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/link"])
      });
    }
  